import { Col, Result, Row, Typography } from 'antd';
import packageJson from '../../package.json';
import errorImage from '../images/error.png';
import { Page } from 'osep-react-antd';

type Props = {
  error?: unknown;
};

const ErrorPage: React.FC<Props> = ({ error }) => {
  if (error) {
    console.error(error);
  }
  return (
    <Page
      footer={<Typography.Text disabled>{packageJson.version}</Typography.Text>}
    >
      <Row justify="center" align="middle" style={{ height: '85vh' }}>
        <Col>
          <Result
            icon={
              <img
                src={errorImage}
                alt="Error"
                style={{ width: '75vw', maxWidth: 500 }}
              />
            }
            status="error"
            title="Ooops, something went wrong!"
            subTitle="Sorry, for the inconvenience. Please reach out to the OSEP team for help."
          />
        </Col>
      </Row>
    </Page>
  );
};

export default ErrorPage;
